<template>
    <div class="authentication">
        <div class="container">
            <div class="row clearfix">
                <div class="col-lg-6 col-md-12">
                    <div class="company_detail">
                        <h4 class="logo">
                            <img class="mr-2" src="@/assets/images/finallogo.png" alt="Logo" />
                            EASY WORK
                        </h4>
                        <h3>업무 능력을 향상 시켜주는 <strong>수월한</strong> 서비스</h3>
                        <p>반복적인 작업을 대신 해줌으로 업무 능력을 향상시켜 줍니다.</p>
                        <br />
                        <!-- <div class="col-sm-10"> -->
                        <img
                            class="rounded"
                            src="@/assets/images/realestate/co1.jpg"
                            alt="Rounded Image"
                            style="width: 100%"
                        />
                        <!-- </div> -->
                        <br />
                        <br />
                        <br />
                        <br />
                        <br />
                        <div class="footer">
                        </div>

                    </div>

                </div>
                <div class="col-lg-6 col-md-12">
                    <div class="card-plain ml-auto">
                        <div class="header">
                            <h5>로그인</h5>
                        </div>

                        <form class="form mt-5">
                            <div class="form-group mb-1">
                                <div class="input-group">
                                    <input
                                        type="text"
                                        class="form-control"
                                        v-model="emailText"
                                        placeholder="이메일"
                                    />
                                </div>
                            </div>
                            <div class="form-group">
                                <div class="input-group">
                                    <input
                                        type="password"
                                        class="form-control"
                                        v-model="passwordText"
                                        placeholder="비밀번호"
                                        v-on:keyup.enter="loginBtn"
                                    />
                                </div>
                                <!-- <a href="forgot-password.html" class="link font-13 float-right">비밀번호를 잊으셨나요?</a> -->
                            </div>
                            <!-- <div class="mt-4">
                                              <label class="c_checkbox">
                                                  <input type="checkbox">
                                                  <span class="checkmark"></span>
                                                  <span class="ml-2">Keep me logged in</span>
                                              </label>
                                          </div> -->
                        </form>

                        <div class="footer mt-3">
                            <a href="#" class="btn btn-secondary btn-block" @click="loginBtn"
                            >로그인</a
                            >
                        </div>
                        <span>회원이 아니신가요?
                            <button type="button" @click="toSignin" class="btn btn-default" style="background: none; border: none; color: #0c85e0;">회원가입하기</button>
                        </span>
                    </div>
                </div>
                <div class="row clearfix">
                    <div class="col-md-12 col-lg-12">
                        <div class="card">
                            <div class="body">
                                <ul class="list-unstyled d-inline-flex mt-2">

                                    <li class="mr-3"><router-link to="/service">서비스 이용약관</router-link></li>
                                    <li class="mr-3"><router-link to="/privacy">개인정보처리방침</router-link></li>
                                    <li class="mr-3"><a href="https://www.easywork.ai" target="_blank">소개</a></li>
                                    <li class="mr-3"><router-link to="/plan-setting">플랜</router-link></li>
                                </ul>
                                <br />
                                <br />
                                <p class="copyright mb-0">
                                    <span style="line-height: 180%">
                                    주식회사 프렌츠 | 주소 : 서울시 마포구 백범로 31길 8 공덕SK리더스뷰 201동 514호<br />
                                    사업자등록번호 : 742-81-01548 | 통신판매신고번호 : 제2022-서울마포-3846호 | 대표이사 : 김호천 | 고객센터 : 02-2038-8990, support@frients.co.kr<br />

                                    Copyright 2022 © All Rights Reserved.
                                    </span>
                                    <a href="http://www.easywork.ai" target="_blank">EASY WORK</a>
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
// import ApiService from '../../service/apiservice';
// import {apiService} from "../../service/apiservice.js";
// import SignInRequest from "@/service/request/SignInRequest";
// import {default as apiservice} from "../../service/apiservice.js";
// import service from "@/service/apiservice";

// console.log(apiService())



export default {
    name: "LoginPage",
    components : {
    },
    data() {
        return {
            emailText: "",
            passwordText: "",
        };
    },
    methods: {
        toSignin(){
            this.$router.push({name:'SignInPage'})
        },
        loginBtn() {
            var emailInput = this.emailText;
            var passwordInput = this.passwordText;
            console.log(emailInput);
            console.log(passwordInput);

            this.api.login({ userEmail: emailInput, userPw: passwordInput }).then((res) => {

                console.log(res)

                if (res["code"] == 0) {

                    this.$store.state.userStore.loginSuccess = true;
                    this.$store.state.userStore.userEmail = res.user.userEmail;
                    this.$store.state.userStore.userCode = res.user.companyCode;
                    this.$store.state.userStore.userName = res.user.companyName;
                    this.$store.state.userStore.apiKey = res.user.apikey;
                    this.$store.state.userStore.trackingCode = res.user.trackingCode;
                    this.$store.state.userStore.siteCode = res.user.siteCode;




                    this.$router.push({name:'WorkflowPage'});
                    // this.$router.push('/')
                    // }

                    // else if(res.data['code'] == 10002) {
                    //     this.emailText = ''
                    //     this.passwordText = ''

                    //     alert('탈퇴된 계정입니다.')
                } else {
                    this.emailText = "";
                    this.passwordText = "";
                    alert("아이디나 비밀번호가 틀립니다");
                }



            })
        },
    },
    created() {
        console.log("LoginPage.created");

        this.$store.state.userStore.loginSuccess = false;
        this.$store.state.userStore.loginError = false;
        this.$store.state.userStore.userEmail = null;
        this.$store.state.userStore.userName = null;
        this.$store.state.userStore.userCode = null;
        this.$store.state.userStore.trackingCode = null;
        this.$store.state.userStore.apiKey = null;
        this.$store.state.userStore.trackAppModal = false;

    },
    mounted() {
        console.log("LoginPage.mounted");
    },
    beforeDestroy() {
        console.log("LoginPage.beforeDestroy");
    }
}


</script>
